import React from 'react'

// CSS
import { H2, Content, BlueStripe } from 'components/StyledComponents'

// Third Party
import _ from 'lodash'
import parse from 'html-react-parser'

const USP = ({ usp, className}) => (
  <div className={`${className ? `${className}` : ``}`}>
    <div className="container py-5">
      <div className="row py-4">
        {_.map(usp, (item, index) => (
          <div key={index} className="col-12 col-lg-3 d-flex d-lg-block flex-wrap justify-content-center justify-content-lg-start">
            <BlueStripe width={52} className="color-background-main mb-2" />
            <H2 className="font-size-xm w-100 text-center text-lg-left font-weight-xl pb-3">{item.title}</H2>
            <Content className="pr-2 w-100 pb-5 pb-lg-0 px-5 px-lg-0 text-center text-lg-left">{parse(item.description)}</Content>
          </div>
        ))}
      </div>
    </div>
  </div>
)

export default USP